/*大于0小于100数字*/
export function validateNumber(val) {
  const reg = /^\d\.([1-9]{1,2}|[0-9][1-9])$|^[1-9]\d{0,1}(\.\d{1,2}){0,1}$|^100(\.0{1,2}){0,1}$/;
  return reg.test(val);
}
/*正整数不含0*/
export function validatePlusNotZero(val) {
  const reg = /^[1-9]\d*$/;
  return reg.test(val);
}
export function validdateMobile(val) {
  const length = val.length;
  var mobile = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/;
  return length == 11 && mobile.test(val);
}
export function validdateJjzzbm(val, xzqh) {
  var Jjzzbm = /^[a-zA-Z0-9]{3}$/;
  if (xzqh.length == 14) {
    Jjzzbm = /^[a-zA-Z0-9]{1}$/;
  } else if (xzqh.length == 12) {
    Jjzzbm = /^[a-zA-Z0-9]{3}$/;
  } else if (xzqh.length == 9) {
    Jjzzbm = /^000[a-zA-Z0-9]{3}$/;
  } else if (xzqh.length == 6) {
    Jjzzbm = /^000[a-zA-Z0-9]{6}$/;
  } else if (xzqh.length == 4) {
    Jjzzbm = /^000[a-zA-Z0-9]{8}$/;
  } else if (xzqh.length == 2) {
    Jjzzbm = /^000[a-zA-Z0-9]{10}$/;
  }
  return Jjzzbm.test(val);
}

export function validPassword(val) {
  const reg = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*])[\da-zA-Z~!@#$%^&*]{6,20}$/;
  return reg.test(val);
}
//ie版本
export function IEVersion() {
  var userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
  var isLessIE11 = // 判断是否为小于IE11的浏览器
    userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;
  var isEdge = userAgent.indexOf("Edge") > -1 && !isLessIE11; // 判断是否为IE的Edge浏览器
  var isIE11 = // 判断是否为IE11浏览器
    userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
  if (isLessIE11) {
    var IEReg = new RegExp("MSIE (\\d+\\.\\d+);");
    // 正则表达式匹配浏览器的userAgent字符串中MSIE后的数字部分，，这一步不可省略！！！
    IEReg.test(userAgent);
    // 取正则表达式中第一个小括号里匹配到的值
    var IEVersionNum = parseFloat(RegExp["$1"]);
    if (IEVersionNum === 7) {
      return 7; // IE7
    } else if (IEVersionNum === 8) {
      return 8; // IE8
    } else if (IEVersionNum === 9) {
      return 9; // IE9
    } else if (IEVersionNum === 10) {
      return 10; // IE10
    }
    return 6; // IE版本<7
  } else if (isEdge) {
    return -2; // edge
  } else if (isIE11) {
    return 11; // IE11
  }
  return -1; // 不是ie浏览器
}
